interface Props {
  color?: string;
}

const WalletIcon: React.FC<Props> = ({ color = "#0D0C21" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.60001 3.19978C4.28404 3.19978 3.20001 4.2838 3.20001 5.59978V18.3998C3.20001 19.7254 4.27441 20.7998 5.60001 20.7998H19.2C20.084 20.7998 20.8 20.0838 20.8 19.1998V7.99978C20.8 7.11578 20.084 6.39978 19.2 6.39978H12.8H5.60001C5.14799 6.39978 4.80001 6.0518 4.80001 5.59978C4.80001 5.14775 5.14799 4.79978 5.60001 4.79978H17.6C17.8885 4.80386 18.1569 4.65227 18.3023 4.40308C18.4478 4.15388 18.4478 3.84568 18.3023 3.59648C18.1569 3.34728 17.8885 3.19571 17.6 3.19979L5.60001 3.19978ZM17.6 11.9998C18.484 11.9998 19.2 12.7158 19.2 13.5998C19.2 14.4838 18.484 15.1998 17.6 15.1998C16.716 15.1998 16 14.4838 16 13.5998C16 12.7158 16.716 11.9998 17.6 11.9998Z"
        fill={color}
      />
    </svg>
  );
};

export default WalletIcon;
